import { createSelector } from 'reselect';

import { selectListingOffers } from './selectListingOffers';
import { selectHiddenOfferIds } from '../hiddenObjects/selectHiddenOfferIds';

export const selectVisibleListingOffers = createSelector(
  selectListingOffers,
  selectHiddenOfferIds,
  (offers, hiddenIds) => offers.filter(offer => !hiddenIds.includes(offer.id)),
);
